export function AtrSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/atr.svg'"></ng-include>`
    }
}